export const i18nFlarePage = {
  filters: {
    actions: {
      csv_pdf: 'Report',
    },
    categories: {
      all_categories: 'All Categories',
      all_categories_value: 'ALL',
      routine: 'Routine',
      non_routine: 'Non Routine',
      safety: 'Safety',
    },
  },
  pdfCsvModal: {
    title: 'Download Report',
    labels: {
      vessel: 'Select a Vessel',
      period: 'Select a period',
      format: 'Select a format',
    },
    buttons: {
      cancel: 'Cancel',
      generate: 'Download',
    },
  },
  vessel: {
    description: 'Vessel:',
    system_label: 'System:',
    utilities_value: 'Utilities (Facilities)',
    subsystem_label: 'Subsystem:',
    subsystem_value: 'Flare / Vent',
    asset_label: 'Asset:',
  },
  summary: {
    events: {
      description: 'An event is generated when the Flow Rate of',
      emissions: 'emissions exceeds the threshold of 1.500 Sm³/hr.',
      text: 'Events',
    },
    total: 'Total',
    volume: {
      sum: 'Sum of all Flare emissions, including those',
      threshold: ' below the threshold (baseline flare).',
      standard: 'The standard temperature condition is',
      degree: ' defined as 15.6 degC',
      text: 'Total volume',
    },
    gas: 'Sm³',
    severity: {
      title: 'Severity',
      3: 'Critical',
      2: 'Major',
      1: 'Minor',
      minor: {
        title: 'Minor event:',
        description: 'Flare volume below 10.000 Sm³',
      },
      major: {
        title: 'Major event:',
        description: 'Flare volume from 10.000 to 100.000 Sm³',
      },
      critical: {
        title: 'Critical event:',
        description: 'Flare volume exceeding 100.000 Sm³',
      },
    },
    categories: {
      routine: 'Routine flaring',
      non_routine: 'Non routine flaring',
      safety: 'Safety flaring',
      tooltip: {
        routine: {
          include:
            'Routine flaring of gas at oil production facilities is flaring during normal oil production operations in the absence of sufficient facilities or amenable geology to re-inject the produced gas, utilize it on-site, or dispatch it to a market. (e.g. Pressure Control Valve Opening)',
          subcategory: '',
          events: '',
        },
        non_routine: {
          include:
            'Non-routine flaring of gas is all flaring other than routine and safety flaring. (e.g. Compressor trip, GTG Trip, Compressor Switchover, Equipment failure, Instrument air failure, Nitrogen failure, well test, Initial start up, and etc.)',
          subcategory: '',
          events: '',
        },
        safety: {
          include:
            'Safety flaring of gas is flaring to ensure safe operation of the facility. (e.g. ASD, ESD, Blowdown valve, Purge gas, assist gas, and pilot gas)',
          subcategory: '',
          events: '',
        },
      },
    },
  },
  tabs: {
    category: 'Events volume by categories',
    subcategory: 'Events volume by subcategories',
  },
  pdf: {
    category: 'Volume by categories',
    subcategory: 'Volume by subcategories',
  },
  bar_chart: {
    empty: 'No events to display on the chart',
    subcategory: {
      tooltip: {
        category: 'Category',
        from: 'From',
        to: 'to',
        volume: 'Total volume',
        events: 'Total events',
      },
    },
  },
  table_message: {
    empty: 'This search returned no results. You can try a wider period or clear the search.',
    comment: {
      empty: 'No comments',
    },
  },
  table: {
    severity: 'Severity',
    volume: 'Volume',
    category: 'Category',
    subcategory: 'Subcategory',
    output_tags: 'System',
    date_start: 'Start',
    duration: 'Duration',
    id: 'ID',
    relevant_subcategory: 'Emb. Subcat.',
    comments: 'Comments',
  },
  modal: {
    comment: {
      title: 'Flaring event ID',
      category: 'Category',
      subcategory: 'Subcategory',
      label: 'Comment',
      placeholder: 'Please, share any relevant information about this event',
      checkbox: 'Check if you consider that the categorization is not accurate',
      button: {
        save: 'Save',
        cancel: 'Cancel',
      },
    },
  },
  line_chart: {
    tabs: {
      general_title: '{{vessel}} Flaring indicator',
      selected_event_title: 'Flaring event ID {{selectedId}}',
    },
    title: 'Flaring indicator',
    flaring_event_legends: {
      critical: 'Critical flare event',
      major: 'Major flare event',
      minor: 'Minor flare event',
    },
    events: 'Events',
    legend: {
      threshold: 'Flare Threshold (1500 Sm³/h)',
    },
    close_event: 'Close event',
  },
};
